import React, { useEffect, useState } from 'react';
import {
    CFormTextarea, CCard, CCardBody, CButton, CModal, CModalHeader,
    CModalTitle, CModalBody, CModalFooter, CRow, CCol, CFormLabel, CFormInput, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CNav, CNavItem, CNavLink, CTabContent, CTabPane
} from '@coreui/react';
import AddMedicationForm from './AddMedicationForm';
import Carder from '../../components/shared/Carder';
import PatientMedications from '../../services/general/patientMedicationData.api';
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import moment from "moment"
import { Medication } from '@mui/icons-material';
import Diagnosis from './Diagnosis';

const ProviderPatientMedication = ({ patientID, patientName = '', facilityName = '', roomNumber = '', loading, setLoading,saveTreatsShell, medicationList, setMedicationList, noteStructureRef, fetchMedications, showComment, appoinmentDate, noteID }) => {
    console.log("medication list ", medicationList)
    const [modalVisible, setModalVisible] = useState(false);
    const [currentDate, setCurrentDate] = useState('');
    const [newMedications, setNewMedications] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [editMedicationBundleListDateId, setEditMedicationBundleListDateId] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [deleteVisibleId, setDeleteVisibleId] = useState(null)

    useEffect(() => {
        setCurrentDate(getFormattedDate());
        fetchMedications();
    }, [patientID]);

    console.log(newMedications, noteID, 'newMedications "noteID',)

    const getFormattedDate = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();
        const hh = String(today.getHours()).padStart(2, '0');
        const min = String(today.getMinutes()).padStart(2, '0');
        return `${mm}.${dd}.${yyyy} ${hh}:${min}`;
    };

    const addMedicationToList = (medication) => {
        const { iseditingList, intervations } = medication
        console.log("medication data , ", medication)
        setNewMedications((prevList) => [...prevList, { ...medication, iseditingList: undefined, }]);
    };

    const handleSaveMedications = async () => {
        if (newMedications.length === 0) {
            toast.error('Please add some medications', toastConfig)
            return false
        }
        setIsLoading(true)
        try {
            console.log("medication ", newMedications, editMedicationBundleListDateId)
            if (editMedicationBundleListDateId) {
                const formattedData = newMedications.map((item) => {
                    return {
                        id: item.id,
                        name: item.name,
                        route: item.route,
                        dosage: item.dosage,
                        frequency: item.frequency,
                        Diagnosis: item?.Diagnosis || [],
                    }
                })

                await PatientMedications("UPDATE", patientID.toString(), JSON.stringify(formattedData), "", editMedicationBundleListDateId.toString());

                setModalVisible(false);

                setEditMedicationBundleListDateId(null)

                fetchMedications()

                setNewMedications([]);

                toast.success('Successfully Updated', toastConfig)
                return true

            } else {


                const formattedData = newMedications.map((item) => {
                    return {
                        // customId: item.id,
                        id: item.id,
                        name: item.name,
                        route: item.route,
                        dosage: item.dosage,
                        frequency: item.frequency,
                        Diagnosis: item?.Diagnosis || [],
                    }
                })
                console.log("medicaitionnnnnnnnnnn", formattedData)
                await PatientMedications("INSERT", patientID.toString(), JSON.stringify(formattedData), getFormattedDate());

                const allMedics = await fetchMedications()

                if (allMedics.length > 0) {
                    setNoteMedicationEditId(allMedics[0]?.id)

                    noteStructureRef.current = {
                        ...noteStructureRef.current,
                        metadata: {
                            ...noteStructureRef.current.metadata,
                            medId: allMedics[0]?.id || ""
                        }
                    }
                    await saveTreatsShell(false)
                }

                setModalVisible(false);

                setNewMedications([]);

                toast.success('Successfully Updated', toastConfig)
                await fetchMedications()
                return true

            }
        } catch (error) {
            console.log(error)
            return false
        } finally {
            setIsLoading(false)
        }
    };

    const handleOnCancelAddingFinalMedication = () => {
        setModalVisible(false);
        setNewMedications([]);
        setNoteMedicationEditId("")
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        // console.log(file);
        // Process the file as needed
    };

    const DeletePatientMedication = async (id) => {
        try {
            await PatientMedications("DELETE", patientID.toString(), "", "", deleteVisibleId?.toString());
            await fetchMedications();
            setDeleteVisibleId(null)
        } catch (error) {
            console.log(error);
        }
    }

    console.log(medicationList, 'medicationList')
    const editMedicationPatient = (med) => {
        console.log('running edit', med)
        const { medications, id, data } = med;
        setEditMedicationBundleListDateId(id)
        setModalVisible(true);
        setNewMedications(data)
        
    }



    const [noteMedicationEditId, setNoteMedicationEditId] = useState("")


    const handleAddMedication = () => {
        // setNewMedications([])
        const findEditMedNoteId = medicationList.length > 0 && medicationList.find((med) => med.id === noteMedicationEditId)
        console.log('running findEditMedNoteId', findEditMedNoteId, noteMedicationEditId,medicationList)
        if (findEditMedNoteId && noteMedicationEditId) {
            
            console.log(findEditMedNoteId, noteMedicationEditId, noteStructureRef, 'findEditMedNoteId && noteMedicationEditId')
            editMedicationPatient(findEditMedNoteId)
        }
        else {
            setEditMedicationBundleListDateId(null)
            // setNewMedications([])
            setModalVisible(true);
        }
    }

    console.log(noteStructureRef, 'setNewMedicationssetNewMedications')



    useEffect(() => {
        const medId = noteStructureRef.current?.metadata?.medId || ""
        console.log(noteStructureRef.current?.metadata?.medId, 'noteStructureRef.current?.metadata?.medId')
        setNoteMedicationEditId(medId)
    }, [])

    // useEffect(() => {
    // }, [noteMedicationEditId])

    console.log(medicationList, 'medicationList')

    return (
      <>
        {/* delete modal */}
        <CModal visible={deleteVisibleId}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              className="text-white"
              color="secondary"
            >
              Close
            </CButton>
            <CButton onClick={DeletePatientMedication} className="text-white" color="danger">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>

        {/* <CNav className="justify-content-center" variant='pills'>
                <CNavItem>
                    <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                        Manual Entry
                    </CNavLink>
                </CNavItem>
                <CNavItem>
                    <CNavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>
                        File Upload
                    </CNavLink>
                </CNavItem>
            </CNav> */}
        <CTabContent className="overflow-hidden">
          <CTabPane visible={activeTab === 0}>
            {/* <CButton style={{ marginTop: "10px" }} onClick={handleAddMedication} variant="outline" color="primary">
                        + Add Medications
                    </CButton> */}
            <div>
              <h6 className="text-white d-flex justify-content-center  ">Current Medications</h6>
              {medicationList.length > 0 &&
                medicationList
                  .filter((med) => noteStructureRef?.current?.metadata?.medId === med.id)
                  .map((medEntry, index) => {
                    return (
                      // <Carder
                      //     // deleteFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { setDeleteVisibleId(medEntry.id) } : null}
                      //     // editFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { editMedicationPatient(medEntry) } : null}
                      //     className={'mt-4'}
                      //     title={`Date:
                      //     ${new Date(medEntry.date).toLocaleDateString('en-US', {
                      //         month: '2-digit',
                      //         day: '2-digit',
                      //         year: 'numeric'
                      //     })}
                      //     `} key={index} style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} >
                      //     <div className='p-4'>
                      //         <p>Date : {new Date(medEntry.date).toLocaleDateString('en-US', {
                      //             month: '2-digit',
                      //             day: '2-digit',
                      //             year: 'numeric'
                      //         })}</p>
                      //         <CTable className=''>
                      //             <CTableHead>
                      //                 <CTableRow>
                      //                     <CTableHeaderCell>Medication Names</CTableHeaderCell>
                      //                     <CTableHeaderCell>Dosage</CTableHeaderCell>
                      //                     <CTableHeaderCell>Route</CTableHeaderCell>
                      //                     <CTableHeaderCell>Frequency</CTableHeaderCell>
                      //                 </CTableRow>
                      //             </CTableHead>
                      //             <CTableBody className='p-0'>
                      //                 {medEntry?.data.map((med, medIndex) => {
                      //                     return(
                      //                         <CTableRow

                      //                         key={medIndex}>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.name}</CTableDataCell>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.dosage}</CTableDataCell>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.route}</CTableDataCell>
                      //                         <CTableDataCell
                      //                         style={{
                      //                             color: med?.inMaster ? "orange" : '',
                      //                         }}
                      //                         >{med.frequency}</CTableDataCell>
                      //                     </CTableRow>
                      //                     )
                      //                 })}
                      //             </CTableBody>
                      //         </CTable>
                      //     </div>
                      // </Carder>
                      <div
                        className="mt-4"
                        style={{
                          borderRadius: '1rem',
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
                          backgroundColor: '#292828ff',
                          color: 'white',
                        }}
                        key={index}
                      >
                        <div className="p-4">
                          <p>
                            Date :{' '}
                            {new Date(medEntry.date).toLocaleDateString('en-US', {
                              month: '2-digit',
                              day: '2-digit',
                              year: 'numeric',
                            })}
                          </p>
                          <CTable
                            className=" "
                            style={{
                              borderCollapse: 'collapse',
                              width: '100%',
                              background: '#292828ff',
                            }}
                          >
                            <CTableHead>
                              <CTableRow>
                                <CTableHeaderCell style={{ color: 'white' }}>Medication Names</CTableHeaderCell>
                                <CTableHeaderCell style={{ color: 'white' }}>Dosage</CTableHeaderCell>
                                <CTableHeaderCell style={{ color: 'white' }}>Route</CTableHeaderCell>
                                <CTableHeaderCell style={{ color: 'white' }}>Frequency</CTableHeaderCell>
                              </CTableRow>
                            </CTableHead>
                            <CTableBody className="p-0 ">
                              {medEntry?.data.map((med, medIndex) => {
                                return (
                                  <CTableRow key={medIndex}>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.name}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.dosage}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.route}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'white',
                                      }}
                                    >
                                      {med.frequency}
                                    </CTableDataCell>
                                  </CTableRow>
                                )
                              })}
                            </CTableBody>
                          </CTable>
                        </div>
                      </div>
                    )
                  })}

              { (medicationList.filter((med) => noteStructureRef?.current?.metadata?.medId === med.id)?.length === 0 && <div className="text-center text-white my-4">No Current Medications Available</div>)}
            </div>

            <div> 
              <div className=" " />
              <div className=" mt-3">
                <h6 className="text-white d-flex justify-content-center  ">Old Medications</h6>

                {medicationList.length > 0 &&
                  medicationList
                    .filter((med) => noteStructureRef?.current?.metadata?.medId !== med.id)
                    .map((medEntry, index) => {
                      return (
                        // <Carder
                        //     // deleteFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { setDeleteVisibleId(medEntry.id) } : null}
                        //     // editFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { editMedicationPatient(medEntry) } : null}
                        //     className={'mt-4'}
                        //     title={`Date:
                        //     ${new Date(medEntry.date).toLocaleDateString('en-US', {
                        //         month: '2-digit',
                        //         day: '2-digit',
                        //         year: 'numeric'
                        //     })}
                        //     `} key={index} style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} >
                        //     <div className='p-4'>
                        //         <p>Date : {new Date(medEntry.date).toLocaleDateString('en-US', {
                        //             month: '2-digit',
                        //             day: '2-digit',
                        //             year: 'numeric'
                        //         })}</p>
                        //         <CTable className=''>
                        //             <CTableHead>
                        //                 <CTableRow>
                        //                     <CTableHeaderCell>Medication Names</CTableHeaderCell>
                        //                     <CTableHeaderCell>Dosage</CTableHeaderCell>
                        //                     <CTableHeaderCell>Route</CTableHeaderCell>
                        //                     <CTableHeaderCell>Frequency</CTableHeaderCell>
                        //                 </CTableRow>
                        //             </CTableHead>
                        //             <CTableBody className='p-0'>
                        //                 {medEntry?.data.map((med, medIndex) => {
                        //                     return(
                        //                         <CTableRow

                        //                         key={medIndex}>
                        //                         <CTableDataCell
                        //                         style={{
                        //                             color: med?.inMaster ? "orange" : '',
                        //                         }}
                        //                         >{med.name}</CTableDataCell>
                        //                         <CTableDataCell
                        //                         style={{
                        //                             color: med?.inMaster ? "orange" : '',
                        //                         }}
                        //                         >{med.dosage}</CTableDataCell>
                        //                         <CTableDataCell
                        //                         style={{
                        //                             color: med?.inMaster ? "orange" : '',
                        //                         }}
                        //                         >{med.route}</CTableDataCell>
                        //                         <CTableDataCell
                        //                         style={{
                        //                             color: med?.inMaster ? "orange" : '',
                        //                         }}
                        //                         >{med.frequency}</CTableDataCell>
                        //                     </CTableRow>
                        //                     )
                        //                 })}
                        //             </CTableBody>
                        //         </CTable>
                        //     </div>
                        // </Carder>
                        <div
                          className="mt-4"
                          key={index}
                          style={{
                            borderRadius: '1rem',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
                            backgroundColor: '#292828ff',
                            color: 'white',
                          }}
                        >
                          <div className="p-4">
                            <p>
                              Date :{' '}
                              {new Date(medEntry.date).toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                              })}
                            </p>
                            <CTable
                              className=" "
                              style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                backgroundColor: '#292828ff',
                              }}
                            >
                              <CTableHead>
                                <CTableRow
                                  style={{
                                    backgroundColor: '#2a2a2a',
                                  }}
                                >
                                  <CTableHeaderCell style={{ color: 'white' }}>Medication Names</CTableHeaderCell>
                                  <CTableHeaderCell style={{ color: 'white' }}>Dosage</CTableHeaderCell>
                                  <CTableHeaderCell style={{ color: 'white' }}>Route</CTableHeaderCell>
                                  <CTableHeaderCell style={{ color: 'white' }}>Frequency</CTableHeaderCell>
                                </CTableRow>
                              </CTableHead>
                              <CTableBody className="p-0">
                                {medEntry?.data.map((med, medIndex) => {
                                  return (
                                    <CTableRow key={medIndex}>
                                      <CTableDataCell
                                        className={med?.inMaster ? 'text-highlight-orange' : ''}
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.name}
                                      </CTableDataCell>
                                      <CTableDataCell
                                        className={med?.inMaster ? 'text-highlight-orange' : ''}
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.dosage}
                                      </CTableDataCell>
                                      <CTableDataCell
                                        className={med?.inMaster ? 'text-highlight-orange' : ''}
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.route}
                                      </CTableDataCell>
                                      <CTableDataCell
                                        className={med?.inMaster ? 'text-highlight-orange' : ''}
                                        style={{
                                          color: med?.inMaster ? 'orange' : 'white',
                                        }}
                                      >
                                        {med.frequency}
                                      </CTableDataCell>
                                    </CTableRow>
                                  )
                                })}
                              </CTableBody>
                            </CTable>
                          </div>
                        </div>
                      )
                    })}

                {medicationList.filter((med) => noteStructureRef?.current?.metadata?.medId !== med?.id)?.length === 0 && <div className="text-center my-4">No Old Medications Available</div>  }
              </div>
            </div>
          </CTabPane>
          <CTabPane visible={activeTab === 1}>
            <CButton style={{ marginTop: '10px' }} variant="outline" color="primary">
              <CFormInput type="file" onChange={handleFileUpload} />
            </CButton>
          </CTabPane>
        </CTabContent>

        <AddMedicationForm
          medicationList={medicationList}
          setMedicationList={setMedicationList}
          handleSaveMedications={handleSaveMedications}
          editMedicationBundleListDateId={editMedicationBundleListDateId}
          handleOnCancelAddingFinalMedication={handleOnCancelAddingFinalMedication}
          setEditMedicationBundleListDateId={setEditMedicationBundleListDateId}
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          newMedications={newMedications}
          setNewMedications={setNewMedications}
          addMedicationToList={addMedicationToList}
          patientID={patientID}
          patientName={patientName}
          facilityName={facilityName}
          roomNumber={roomNumber}
          appoinmentDate={appoinmentDate}
          noteID={noteID}
        />
      </>
    )
};

export default ProviderPatientMedication;
